import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ShippingAvailability extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
    this.#bindToggle(); 
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  /**
   * Updates the shipping availability display.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateAvailability = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newAvailability = event.detail.data.html.querySelector('shipping-availability');

    if (!newAvailability) return;

    const wasExpanded = this.querySelector('[data-sa-toggle]')?.getAttribute('aria-expanded') === 'true';

    morph(this, newAvailability, { childrenOnly: true });

    if (wasExpanded) {
      const toggle = this.querySelector('[data-sa-toggle]');
      const info = this.querySelector('[data-sa-info]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (info) info.setAttribute('aria-hidden', 'false');
    }

    this.#bindToggle();
  };

  #bindToggle() {
    const toggle = this.querySelector('[data-sa-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', this.#handleToggle);
  }

  #handleToggle = () => {
    const toggle = this.querySelector('[data-sa-toggle]');
    const info = this.querySelector('[data-sa-info]');
    if (!toggle || !info) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    info.setAttribute('aria-hidden', String(expanded));
  };
}

if (!customElements.get('shipping-availability')) {
  customElements.define('shipping-availability', ShippingAvailability);
}
